module.exports = __webpack_public_path__ + "img/hh-5.7b70b16b.png";